import { useNavigation } from '@react-navigation/native'
import { TouchableOpacity, Text } from 'react-native'
import React from 'react'
import { IconArrowBack } from '../../assets/icons'
import { paths } from '../links'
import * as navigationObj from '../Supplier/RootNavigation'
import { useTranslation } from 'react-i18next'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { useResponsive } from '../../utils/hooks'
import { Spacer } from '../../ui/atoms'
import RootStore from '../../store'

type BackButtonProps = {
  toScreen?: string
  onPress?: () => void
  testID?: string
}

export const BackRoundIcon = (props: BackButtonProps) => {
  return (
    <TouchableOpacity
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        height: 56,
        width: 56,
        borderRadius: 56,
        backgroundColor: '#F4F9FD',
      }}
      onPress={props.onPress}
      testID={props.testID}
    >
      <IconArrowBack width={16} height={16} />
    </TouchableOpacity>
  )
}

export const BackWithText = ({ onPress, testID }: BackButtonProps) => {
  const { t } = useTranslation('global')
  return (
    <TouchableOpacity
      onPress={onPress}
      style={{ flexDirection: 'row', alignItems: 'center' }}
      testID={testID}
    >
      <IconArrowBack width={16} height={16} />
      <Text
        style={{
          fontWeight: '500',
          color: commonColors.accentText,
          marginLeft: 5,
        }}
      >
        {t('back')}
      </Text>
    </TouchableOpacity>
  )
}

export default (props: BackButtonProps) => {
  const { sm } = useResponsive()
  let navigation
  try {
    navigation = useNavigation()
  } catch (e) {
    navigation = navigationObj
  }
  const onBack = () => {
    if (props.onPress) {
      props.onPress()
    } else if (navigation.canGoBack()) {
      navigation.goBack()
    } else {
      navigation.navigate(props.toScreen || paths.Auth.SignIn)
    }
  }
  return sm ? (
    <>
      <BackRoundIcon {...props} onPress={onBack} />
      <Spacer height={40} />
    </>
  ) : RootStore.branding ? (
    <>
      <BackWithText {...props} onPress={onBack} />
      <Spacer height={10} />
    </>
  ) : null
}
